export default {
  getUsername: (state) => state.username,
  isLoggedIn: (state) => state.isLoggedIn,
  isInRole: (state) => (role) => state.roles.some((r) => r === role),
};
